var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.arr),function(item){return _c('van-cell',{key:item.tempCode,attrs:{"title":item.displayName,"is-link":""},on:{"click":function($event){return _vm.viewPdf(item.tempCode)}}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }